import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const nocodb = defineConnector({
  identifier: "nocodb",
  name: "NocoDB",
  tagLine: "Open source Airtable alternative",
  logo,
  protocol: "http",
  tags: ["data", "engineering"],
  defaultUrlPattern: ({ host }) =>
    host
      ? `https://${host.replace(/\./g, "\\.")}/.*`
      : "https://.*\\.nocodb\\.com/.*",
  auth: (app) => headerAuth([{ name: "xc-token", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your NocoDB dashboard, click your profile icon, go to **API Tokens**, and create a new token.",
        },
      ],
    },
    {
      title: "Enter your instance URL",
      items: [
        {
          kind: "input",
          label: "NocoDB host",
          placeholder: "app.nocodb.com",
          required: true,
          target: { kind: "configuration", field: "host" },
        },
      ],
    },
    {
      title: "Copy and paste the API token into the field below",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/api/v2/meta/tables`,
  },
});
